<ng-container>
    <div class="left" style="padding-bottom: 15px;">
        <h4 i18n="@@bc122c6e518f00d95e8fc4c69ea553c30bec434e" t="bc122c6e518f00d95e8fc4c69ea553c30bec434e">
            History:
        </h4>
    </div>
    <!-- grid start -->
    <table tsl-table [dataSource]="datasource" displayStripes="true">
        <!-- Action Date Column -->
        <ng-container tslColumnDef="modifiedon">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@2e695d44b87621093cdd9d26c89b72aedd8ad061"
                t="2e695d44b87621093cdd9d26c89b72aedd8ad061"
            >
                Action Date
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getTimestamp(row.startTime) }}</td>
        </ng-container>

        <!-- User Column -->
        <ng-container tslColumnDef="modifiedby">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@e08a77594f3d89311cdf6da5090044270909c194"
                t="e08a77594f3d89311cdf6da5090044270909c194"
            >
                User
            </th>
            <td tsl-cell *tslCellDef="let row">{{ row.modifiedBy }}</td>
        </ng-container>

        <!-- Location Column -->
        <ng-container tslColumnDef="location">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2"
                t="ed31c09fd77c36238c13d83635f3fe5294c733d2"
            >
                Location
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getFullLocation(row.locationId) }}</td>
        </ng-container>

        <!-- Model Column -->
        <ng-container tslColumnDef="model">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@6ec98fa3d6504ba1fd03465194b53706c8263c99"
                t="6ec98fa3d6504ba1fd03465194b53706c8263c99"
            >
                Model
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getModelName(row.modelTypeId) }}</td>
        </ng-container>

        <!-- Tire Size Column -->
        <ng-container tslColumnDef="tiresize">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@3ad1d838b44d79edfc181316fa94c26ad69e97de"
                t="3ad1d838b44d79edfc181316fa94c26ad69e97de"
            >
                Tire Size
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getTireSize(row.tireSizeId) }}</td>
        </ng-container>

        <!--Previous Quantity Column -->
        <ng-container tslColumnDef="prevquantity">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@ea85adfdaec5e5dabe75b35dc025026dd9fc6a01"
                t="ea85adfdaec5e5dabe75b35dc025026dd9fc6a01"
            >
                Previous Quantity
            </th>
            <td tsl-cell *tslCellDef="let row">{{ row.previousQuantity }}</td>
        </ng-container>

        <!--Updated Quantity Column -->
        <ng-container tslColumnDef="updatedquantity">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@27ab0467c3ee94d075e71ea46b02febcc1ae98ac"
                t="27ab0467c3ee94d075e71ea46b02febcc1ae98ac"
            >
                Updated Quantity
            </th>
            <td tsl-cell *tslCellDef="let row">{{ row.updatedQuantity }}</td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- grid pagination -->
    <tsl-pagination
        showFirstLastButtons
        [pageSizeOptions]="pageSizeOptions"
        [total]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (pageChange)="onPageChange($event)"
        [itemsPerPageLabel]="translateService.get('ItemsPerPage')"
    >
    </tsl-pagination>

    <div class="right">
        <button
            tsl-button
            size="small"
            color="black"
            outline
            (click)="onClose()"
            i18n="@@d7b35c384aecd25a516200d6921836374613dfe7"
            t="d7b35c384aecd25a516200d6921836374613dfe7"
        >Cancel</button>
    </div>
</ng-container>
